import React, { useContext, useState, useEffect } from 'react'
import { DashboardContext } from 'live/context/dashboard'
import * as _ from 'lodash'
import LiveLoading from 'live/components/ui/Loading'
import { useThemeContext } from '@intelie/ui'

import Highcharts from 'highcharts2/highcharts-gantt'
import HighchartsReact from 'highcharts-react-official'
import { turnIntoGanttSeries, getAssetName, getTreeUnformatted } from './utils/utils'

import HC_more from 'highcharts2/highcharts-more' //module
HC_more(Highcharts) //init module

const initialState: UnformattedTreeProps = { interventions: [] }

export default ({ width, height }): React.ReactElement => {
    const [options, setOptions] = useState({})
    const context: any = useContext(DashboardContext)
    const [asset, setAsset] = useState<string>(getAssetName(context?.params?.filter, undefined))
    const [tree, setTree] = useState<UnformattedTreeProps>(initialState)
    const [fetchingTree, setFetchingTree] = useState<boolean>(false)
    const [error, setError] = useState<boolean>(false)
    const theme = useThemeContext().theme

    useEffect(() => {
        setAsset(getAssetName(context?.params?.filter, undefined))
    }, [context.params.filter])

    useEffect(() => {
        setTree(initialState) // to show loading indicator
        setOptions({})
        getTreeUnformatted(asset, setFetchingTree, setError).then(r => {
            setTree(r.tree)
        })
    }, [asset])

    useEffect(() => {
        if (tree && tree.interventions && tree.interventions.length > 0) {
            setOptions({
                chart: {
                    width: width,
                    height: height,
                    backgroundColor: 'transparent'
                },
                yAxis: {
                    uniqueNames: false,
                    labels: {
                        formatter: function () {
                            return this.value
                        },
                        style: {
                            color: theme["gray-800"]
                        }
                    }
                },
                navigator: {
                    enabled: true,
                    liveRedraw: true,
                    series: {
                        type: 'gantt',
                        pointPlacement: 0.5,
                        pointPadding: 0.25,
                        accessibility: {
                            enabled: false
                        }
                    },
                    yAxis: {
                        min: 0,
                        max: 3,
                        reversed: true,
                        categories: []
                    }
                },
                scrollbar: {
                    enabled: true
                },
                rangeSelector: {
                    enabled: true,
                    selected: 5
                },
                xAxis: [
                    {
                        dateTimeLabelFormats: {
                            week: {
                                list: ['Week %W', 'W%W']
                            }
                        },
                        labels: {
                            style: {
                                color: theme["gray-800"]
                            }
                        }
                    },
                    {
                        dateTimeLabelFormats: {
                            month: {
                                list: ['%B %Y']
                            }
                        },
                        labels: {
                            style: {
                                color: theme["gray-800"]
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '-',
                        data: turnIntoGanttSeries(tree)
                    }
                ]
            })
        }
    }, [tree, width, height])

    return (
        <>
            {' '}
            {fetchingTree && <LiveLoading />}
            {!fetchingTree && error && <div>Houve algum erro na solicitação das operações.</div>}
            {!fetchingTree && !error && options.series && (
                <HighchartsReact constructorType={'ganttChart'} highcharts={Highcharts} options={options} />
            )}
            {!fetchingTree && !error && !options.series && <div> Sem dados </div>}
        </>
    )
}
